import React from 'react';
import { Lock, Users } from 'lucide-react';

interface FolderSelectorProps {
  hasFolder: boolean;
  folderName?: string;
  onClick: (e: React.MouseEvent) => void;
  className?: string;
}

/**
 * Shared folder selector component used in both grid and list views
 * Displays folder icon (Lock for private, Users for shared) with folder name
 */
export const FolderSelector: React.FC<FolderSelectorProps> = ({
  hasFolder,
  folderName,
  onClick,
  className = '',
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center gap-1 hover:text-foreground transition-colors ${className}`}
    >
      {hasFolder ? <Users className="h-3 w-3" /> : <Lock className="h-3 w-3" />}
      <span className="truncate max-w-[100px]">{folderName || 'Private'}</span>
    </button>
  );
};
